// extracted by mini-css-extract-plugin
export default {"header":"MainHeader_header__3uwDL","appBar":"MainHeader_appBar__ASlvs","toolBar":"MainHeader_toolBar__Wintz","box":"MainHeader_box__FGJuk"};